// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__10tN6","title":"Header_title__ziacm","side":"Header_side__RQhai"};